import { c as _c } from "react-compiler-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const Translate01 = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.2,
      d: "M12.913 17h7.174m-7.174 0L11 21m1.913-4 2.8653-5.991c.2309-.4827.3463-.7241.5043-.8004a.5.5 0 0 1 .4348 0c.158.0763.2734.3177.5043.8004L20.087 17m0 0L22 21M2 5h6m0 0h3.5M8 5V3m3.5 2H14m-2.5 0c-.4961 2.9573-1.6474 5.6362-3.3344 7.8844M10 14c-.6125-.2752-1.2373-.6579-1.8345-1.1156m0 0C6.813 11.8478 5.6029 10.4266 5 9m3.1655 3.8844C6.561 15.0229 4.4716 16.7718 2 18"
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = /*#__PURE__*/_jsx("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: t0
    });
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default Translate01;
//# sourceMappingURL=Translate01.js.map